module.exports = __webpack_public_path__ + "img/PR.fcec6063.svg";